module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"social_events":{"index":{"event_list":{"results_html":"<strong>0</strong> upcoming events | <strong>One</strong> upcoming Event | <strong>%{count}</strong> upcoming events","past_events":"Past events"}}}}}}}')
  delete Component.options._Ctor
}
